<template>
    <div>
        <div class="file-list">
            <div class="file-list__item">
                <file-item v-if="file" :file="file" @remove="remove"/>
            </div>
        </div>

        <div class="elementary-section__controls button-fix">
            <custom-button @click="saveFiles" small outline>Vybrat soubor</custom-button>
        </div>
    </div>
</template>

<script>
import FileList from './FileList';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import FilePickerDialog from 'domovio-core/src/modules/MediaModule/components/File/FilePickerDialog';
import FileItem from '@/modules/ProjectModule/modules/UnitModule/components/File/FileItem';

export default {
    name:       'FileCard',
    components: {FileItem, CustomButton, FileList},
    computed:   {
        file() {
            return this.unitData.hasOwnProperty('cardFile') ? this.unitData.cardFile : null;
        },
        unitData() {
            return this.$store.getters['projects/project/units/unit/unitData'];
        },
        cardFileId() {
            return this.$store.getters['projects/project/units/unit/cardFileId'];
        }
    },
    methods:    {
        saveFiles() {
            this.$modal.show(FilePickerDialog, {
                multipleSelect: false,
                onSelect:       ({fileIds}) => {
                    if (fileIds.length === 1) {
                        this.$store.dispatch('projects/project/units/unit/updateUnit', {cardFileId: fileIds[0]})
                            .catch((message) => this.$dmv.notifyError(message));
                    }
                    this.$modal.hideAll();
                },
                onCancel:       () => this.$modal.hideAll(),
            }, defaultModalParameters({
                maxWidth: 700,
                width:    700,
            }));
        },
        remove() {
            this.$store.dispatch('projects/project/units/unit/updateUnit', {cardFileId: null})
                .catch((message) => this.$dmv.notifyError(message));
        }
    }
}
</script>
